const gallery1 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery1.jpg?updatedAt=1759422696901";
const gallery2 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery2.jpg?updatedAt=1759422696799";
const gallery3 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery3.jpg?updatedAt=1759422696908";
const gallery4 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery4.jpg?updatedAt=1759422696867";
const gallery5 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery5.jpg?updatedAt=1759422696898";
const gallery6 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery6.jpg?updatedAt=1759422696875";
const gallery7 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery7.jpg?updatedAt=1759422696845";
const gallery8 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery8.jpg?updatedAt=1759422696810";
const gallery9 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery9.jpg?updatedAt=1759422696886";
const gallery10 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery10.jpg?updatedAt=1759422696896";
const gallery11 = "https://ik.imagekit.io/sbrqdqxneo/gallery/gallery11.jpg?updatedAt=1759422697026";

export {
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
};
